import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 語言資源
import translationZhTW from './locales/zh-TW.json';
import translationEn from './locales/en.json';
import translationJa from './locales/ja.json';

// 從本地存儲獲取保存的語言設置，預設為繁體中文
const savedLanguage = localStorage.getItem('250705_language') || 'zh-TW';

const resources = {
  'zh-TW': {
    translation: translationZhTW
  },
  'en': {
    translation: translationEn
  },
  'ja': {
    translation: translationJa
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'zh-TW',
    interpolation: {
      escapeValue: false // React 已經安全轉義
    },
    react: {
      useSuspense: true
    }
  });

export default i18n;
